module.exports = __webpack_public_path__ + "static/media/bocireland.724fa4f9.jpg";